import {
  EigentuemerPrintOptionsMeta,
  GrundstueckPrintOptionsMeta,
  PrintConfigResponseMeta,
  RechtPrintOptionsMeta
} from '../gb-api';
import { AppAuszugCookieService } from './app-auszug-cookie-service';

interface PrintConfig {
  getRechtAuszugOptions(): RechtPrintOptionsMeta;

  getGrundstueckAuszugOptions(): GrundstueckPrintOptionsMeta;

  getEigentuemerAuszugOptions(): EigentuemerPrintOptionsMeta;

  updateRechtAuszugOptions(value: RechtPrintOptionsMeta);

  updateGrundstueckAuszugOptions(value: GrundstueckPrintOptionsMeta);

  updateEigentuemerAuszugOptions(value: EigentuemerPrintOptionsMeta);

  getRechtDefaultSettings(): RechtPrintOptionsMeta;

  getGrundstueckDefaultSettings(): GrundstueckPrintOptionsMeta;

}

export class AppPrintConfig implements PrintConfig {

  pringConfigResponseDefaults: PrintConfigResponseMeta;


  constructor(protected printConfigResponse: PrintConfigResponseMeta) {
    this.pringConfigResponseDefaults = { ...this.printConfigResponse };
    this.pringConfigResponseDefaults.grundstueckPrintOptions = { ...this.printConfigResponse.grundstueckPrintOptions };
    this.pringConfigResponseDefaults.rechtPrintOptions = { ...this.printConfigResponse.rechtPrintOptions };
    this.pringConfigResponseDefaults.eigentuemerPrintOptions = { ...this.printConfigResponse.eigentuemerPrintOptions };
  }

  getRechtAuszugOptions(): RechtPrintOptionsMeta {
    return { ...this.printConfigResponse.rechtPrintOptions };
  }

  getGrundstueckAuszugOptions(): GrundstueckPrintOptionsMeta {
    return { ...this.printConfigResponse.grundstueckPrintOptions };
  }

  getEigentuemerAuszugOptions(): EigentuemerPrintOptionsMeta {
    return { ...this.printConfigResponse.eigentuemerPrintOptions };
  }

  updateRechtAuszugOptions(value: RechtPrintOptionsMeta) {
    this.printConfigResponse.rechtPrintOptions = value;
  }

  updateGrundstueckAuszugOptions(value: GrundstueckPrintOptionsMeta) {
    this.printConfigResponse.grundstueckPrintOptions = value;
  }

  updateEigentuemerAuszugOptions(value: EigentuemerPrintOptionsMeta) {
    this.printConfigResponse.eigentuemerPrintOptions = value;
  }

  getRechtDefaultSettings(): RechtPrintOptionsMeta {
    return { ...this.pringConfigResponseDefaults.rechtPrintOptions };
  }

  getGrundstueckDefaultSettings(): GrundstueckPrintOptionsMeta {
    return { ...this.pringConfigResponseDefaults.grundstueckPrintOptions };
  }
}

export class CookiePrintConfig extends AppPrintConfig {

  constructor(printConfigResponse: PrintConfigResponseMeta, private printCookieSettingService: AppAuszugCookieService) {
    super(printConfigResponse);
  }

  async init(): Promise<void> {
    await Promise.all([
      this.printCookieSettingService.saveRechtCookies(
        this.printConfigResponse.rechtPrintOptions,
        true
      ),
      this.printCookieSettingService.saveGrundstueckCookies(
        this.printConfigResponse.grundstueckPrintOptions,
        true
      ),
      this.printCookieSettingService.saveEigentuemerCookies(
        this.printConfigResponse.eigentuemerPrintOptions,
        true
      )
    ]);
  }

  async updateRechtAuszugOptions(value: RechtPrintOptionsMeta) {
    super.updateRechtAuszugOptions(value);
    await this.printCookieSettingService.saveRechtCookies(value, true);
  }

  async updateGrundstueckAuszugOptions(value: GrundstueckPrintOptionsMeta) {
    super.updateGrundstueckAuszugOptions(value);
    await this.printCookieSettingService.saveGrundstueckCookies(value, true);
  }

  async updateEigentuemerAuszugOptions(value: EigentuemerPrintOptionsMeta) {
    super.updateEigentuemerAuszugOptions(value);
    await this.printCookieSettingService.saveEigentuemerCookies(value, true);
  }

  getGrundstueckAuszugOptions(): GrundstueckPrintOptionsMeta {
    return this.printCookieSettingService.readGrundstueckCookies(this.printConfigResponse.grundstueckPrintOptions);
  }

  getEigentuemerAuszugOptions(): EigentuemerPrintOptionsMeta {
    return this.printCookieSettingService.readEigentuemerCookies(this.printConfigResponse.eigentuemerPrintOptions);
  }

  getRechtAuszugOptions(): RechtPrintOptionsMeta {
    return this.printCookieSettingService.readRechtCookies(this.printConfigResponse.rechtPrintOptions);
  }

}
